/**
 * Is de klant ná dit bronbericht al door ons beantwoord?
 *
 * Klasse (Travelbase 17-09): de composer vulde het lezer-concept opnieuw in
 * en toonde "Verstuur", terwijl het antwoord al om 15:50 de deur uit was. Het
 * concept hangt aan het klantbericht en niemand markeert het na verzending;
 * de waarheid is het uitgaande bericht zélf. Dezelfde vraag beslist of een
 * onbesliste kaart nog actueel is.
 *
 * "Beantwoord" = een uitgaand bericht ná de bron dat aan de afzender van de
 * bron is gericht (aan of cc). Een doorstuur naar een partner telt niet: de
 * klant heeft dan nog niets gehoord. Zonder bekend afzenderadres telt elk
 * uitgaand bericht ná de bron.
 */
export interface BeantwoordBericht {
  is_incoming: boolean;
  message_date: string;
  from_email?: string | null;
  to_email?: string | null;
  cc_email?: string | null;
}

function bevatAdres(veld: string | null | undefined, adres: string): boolean {
  return !!veld && veld.toLowerCase().includes(adres);
}

export function isKlantBeantwoordNa(messages: ReadonlyArray<BeantwoordBericht>, bron: BeantwoordBericht | null | undefined): boolean {
  if (!bron) return false;
  const klantAdres = bron.from_email?.trim().toLowerCase() || null;
  return messages.some((m) => {
    if (m.is_incoming || !(m.message_date > bron.message_date)) return false;
    if (!klantAdres) return true;
    return bevatAdres(m.to_email, klantAdres) || bevatAdres(m.cc_email, klantAdres);
  });
}
